import { isPlatformBrowser } from '@angular/common';
import { Component, EventEmitter, Inject, OnInit, Output, PLATFORM_ID } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from '../../../../environments/environment';
import { NgxSpinnerService } from 'ngx-spinner';
import { Subscription } from 'rxjs';
import { ApiService } from '../../../shared/services/apiService.service';
import { BehaviourSubjectService } from '../../../shared/services/behaviour-subject.service';
import { secureStorage } from '../../../shared/services/encryption/secureservice';



@Component({
  selector: 'app-reward-center',
  templateUrl: './reward-center.component.html',
  styleUrls: ['./reward-center.component.scss']
})
export class RewardCenterComponent implements OnInit {

  sub: Subscription = new Subscription();
  height: number = 0;
  width: number = 0;
  isMobile: boolean = false;
  environment1 = environment.s3bucket.url;
  loyalityRewards: any;
  totalRewardCard: any;
  itemsPerPage: any = 10;
  currentPage: any = 1;
  totalItemsTD: any = 0;
  totalItemsBooking: any = 10
  productDetailList: any;
  maximumSize: any = 10;
  totalItemsOffers: any = 0
  skuData: any;
  cardName: any;
  hasImage: boolean = false;
  userBalance: any;
  balance: any;
  currentRoute: any;
  searchData: any;


  constructor(private router: Router,
    @Inject(PLATFORM_ID) private platformId: Object,
    private spinner: NgxSpinnerService,
    private apiService: ApiService,
    private behaviourSubject: BehaviourSubjectService,
    private localStorage: secureStorage,

  ) {}

  ngOnInit(): void {
    if (isPlatformBrowser(this.platformId)) {
      this.height = window.innerHeight;
      this.width = window.innerWidth
      if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
        this.isMobile = true;
      } else {
        this.isMobile = false;
      }

      this.currentPage = 1;
      this.pageChangeLoyalityReward(this.currentPage)

       this.userBalance = JSON.parse(this.localStorage.getItem('userBalLocalSto') || 'null');
       this.balance = this.userBalance.user_balance_list[0].current_balance

       localStorage.removeItem('currentRoute');
      localStorage.removeItem('rewardTermsCondition');
    this.currentRoute = this.router.url;
    }
  }


  navigateToReward(reward) {
    // JSON.stringify(this.localStorage.setItem('rewardImage', reward))
    this.localStorage.setItem('rewardData', JSON.stringify(reward));
    this.router.navigate(['/account/reward-gift-card']);
  }

  TnCredirect(){
    this.localStorage.setItem('currentRoute', this.currentRoute);

    this.router.navigate(['/reward-terms-condition']);

  }

  pageChangeLoyalityReward(page: any) {
    this.currentPage = page;
    page = page - 1;
    let reqBody =
    {
      "category":"Voucher",
      "offset": page,
      "limit": 10
    };
    if (this.searchData?.trim()) {
      reqBody["product"] = this.searchData.trim();
    }
    this.getLoyalityRewards(reqBody);

  }



  getLoyalityRewards(reqBody: any) {
    try {
      this.loyalityRewards = [];
      this.totalRewardCard = [];
      this.totalItemsOffers = 0;
      this.spinner.show();
      this.sub.add(
        this.apiService.getRedemptiomProduct(reqBody).subscribe({
          next: (res) => {
            if (res.success) {
              this.loyalityRewards = res.data;
              this.totalRewardCard = res;
              this.totalItemsOffers = res.redemption_count;
            }else{
              this.loyalityRewards = [];
              this.totalRewardCard = [];
              this.totalItemsOffers = 0;
            }
            this.spinner.hide();
          },
          error: () => this.spinner.hide(),
          complete: () => this.spinner.hide(),
        })
      );
    } catch (error) {
      this.spinner.hide();
      this.loyalityRewards = [];
      this.totalRewardCard = [];
      this.totalItemsOffers = 0;
    }
  }


  mobileBack() {
    this.router.navigate(['/account/rewardsPage']);

  }
  searchAll() {
    const searchQuery = this.searchData ? this.searchData.trim() : '';
    if (searchQuery === '') {
      this.pageChangeLoyalityReward(this.currentPage);
      return;
    }
    let reqBody = {
      "category": "Voucher",
      "offset": 0, // Reset pagination on search
      "limit": 10,
      "product": searchQuery // Sending search query to API
    };
  
    this.getLoyalityRewards(reqBody);
  }
  onSearchInput() {
  if (!this.searchData?.trim()) {
    this.pageChangeLoyalityReward(this.currentPage);
  }
}
  ngOnDestroy(): void {
    this.sub.unsubscribe();
  }

}
